module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '' && _vm.form.fields.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Név")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.nev),
      expression: "form.hallgato_alapadatok.nev"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "nev"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.nev)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.nev = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Neptun azonosító")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.neptunkod),
      expression: "form.hallgato_alapadatok.neptunkod"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "neptunkod"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.neptunkod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.neptunkod = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Szak")]), _vm._v(" "), _c('p', {
    staticClass: "form-group-info"
  }, [_vm._v("(A szak képesítési követelményeit meghatározó Korm. rendelet szerinti megnevezés).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.szak),
      expression: "form.hallgato_alapadatok.szak"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "szak"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.szak)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.szak = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Teljesített aktív félévek száma")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.aktiv_felevek_szama),
      expression: "form.hallgato_alapadatok.aktiv_felevek_szama"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "aktiv_felevek_szama"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.aktiv_felevek_szama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.aktiv_felevek_szama = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Születési hely, idő")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.szulhelyido),
      expression: "form.hallgato_alapadatok.szulhelyido"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "szulhelyido"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.szulhelyido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.szulhelyido = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Kar")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kar),
      expression: "form.hallgato_alapadatok.kar"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kar"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kar = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Képzés szintje")]), _vm._v(" "), _c('p', {
    staticClass: "form-group-info"
  }, [_vm._v(" ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kepzes_szint),
      expression: "form.hallgato_alapadatok.kepzes_szint"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kepzes_szint"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kepzes_szint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kepzes_szint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Megszerzett kreditpontok száma")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_alapadatok.kreditek_szama),
      expression: "form.hallgato_alapadatok.kreditek_szama"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "kar"
    },
    domProps: {
      "value": (_vm.form.hallgato_alapadatok.kreditek_szama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_alapadatok.kreditek_szama = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Tanulmányok\n        ")]), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "label": "Szakok",
      "id": "szak_id",
      "name": "szak_id",
      "options": _vm.szak_combo_opts
    },
    on: {
      "onChange": function (index) {
        _vm.szakValt(index, true, true);
      }
    },
    model: {
      value: (_vm.szak_combo_index),
      callback: function($$v) {
        _vm.szak_combo_index = $$v
      },
      expression: "szak_combo_index"
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Az utolsó két lezárt félév átlaga")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("I. félév")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.felev1),
      expression: "form.hallgato_atlagok.felev1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_ef"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.felev1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.felev1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("II. félév")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.felev2),
      expression: "form.hallgato_atlagok.felev2"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_mf"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.felev2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.felev2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Átlag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hallgato_atlagok.atlag),
      expression: "form.hallgato_atlagok.atlag"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "text",
      "name": "tanulm_atlag"
    },
    domProps: {
      "value": (_vm.form.hallgato_atlagok.atlag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.hallgato_atlagok.atlag = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', [_vm._v("Nyelvvizsgák")]), _vm._v(" "), _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Kizárólag a Neptun rendszerben a Tanulmányi Ügyintéző által rögzített nyelvvizsgá(k)oz van lehetőség mellékletként a bizonyítvány másolatának feltöltésére.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('nyelvtudas').name,
    ref: "nyelvtudas",
    attrs: {
      "hide_point": true,
      "block_once": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('nyelvtudas').accepted_files,
      "options": _vm.getFieldByName('nyelvtudas').options,
      "id": _vm.getFieldByName('nyelvtudas').name,
      "label": _vm.getFieldByName('nyelvtudas').label,
      "name": _vm.getFieldByName('nyelvtudas').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'nyelvtudas');
      }
    }
  })], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kutatasi_tema_cime",
      "label": "Kutatási téma címe",
      "name": "kutatasi_tema_cime"
    },
    model: {
      value: (_vm.form.values.kutatasi_tema_cime),
      callback: function($$v) {
        _vm.form.values.kutatasi_tema_cime = $$v
      },
      expression: "form.values.kutatasi_tema_cime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Kutatása kapcsolódik a megjelölt témához/témákhoz")]), _vm._v(" "), _vm._l((_vm.getFieldByName('temak').options), function(option, i) {
    return _c('div', {
      staticClass: "form-checkbox-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.values.temak),
        expression: "form.values.temak"
      }],
      attrs: {
        "id": 'temak_' + i,
        "name": 'temak_' + i,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.form.values.temak) ? _vm._i(_vm.form.values.temak, option.value) > -1 : (_vm.form.values.temak)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.form.values.temak,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.form.values.temak = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.values.temak = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.form.values.temak = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'temak_' + i
      }
    }, [_c('div', {
      staticClass: "icon"
    }), _vm._v("\n              " + _vm._s(option.text) + "\n            ")])])
  }), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'temak') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "maxlength": "4000",
      "tooltipDescription": "Motivációs levél (karakterszám szóközzel együtt min 2000 - max 4000) - mely részletezi a pályázó jövőbeli szakmai terveit, valamint indokolja, hogy a kutatási témája miként is kapcsolódik a fent meghatározott témakörhöz/témakörökhöz",
      "autogrow": true,
      "errors": _vm.errors,
      "id": "motivacios_level",
      "label": "Motivációs levél",
      "name": "motivacios_level"
    },
    model: {
      value: (_vm.form.values.motivacios_level),
      callback: function($$v) {
        _vm.form.values.motivacios_level = $$v
      },
      expression: "form.values.motivacios_level"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('mellekletek').name,
    ref: "mellekletek",
    attrs: {
      "tooltipDescription": "Az összes melléklethez kötelező fájlt csatolni",
      "hide_point": true,
      "block_once": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('mellekletek').accepted_files,
      "options": _vm.getFieldByName('mellekletek').options,
      "id": _vm.getFieldByName('mellekletek').name,
      "label": _vm.getFieldByName('mellekletek').label,
      "name": _vm.getFieldByName('mellekletek').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'mellekletek');
      }
    }
  })], 1), _vm._v(" "), (_vm.doktorandusz()) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name,
    ref: "megjelent_publikaciok_mtmt_lista_alapjan",
    attrs: {
      "tooltipDescription": "Tételes lista a pályázat benyújtásának időpontjáig megjelent publikációkról: MTMT-ből nyomtatott teljes lista a presztízs és szponzor adatok jelölésével, valamint az MTMT Közlemény és idéző összefoglaló táblázat",
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').accepted_files,
      "options": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').options,
      "id": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name,
      "label": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').label,
      "name": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'megjelent_publikaciok_mtmt_lista_alapjan');
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('otdk').name,
    ref: "otdk",
    attrs: {
      "hide_point": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('otdk').accepted_files,
      "options": _vm.getFieldByName('otdk').options,
      "id": _vm.getFieldByName('otdk').name,
      "label": _vm.getFieldByName('otdk').label,
      "name": _vm.getFieldByName('otdk').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'otdk');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('hazi_tmdk').name,
    ref: "hazi_tmdk",
    attrs: {
      "hide_point": true,
      "enable_block_delete": false,
      "hide_all_options": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('hazi_tmdk').accepted_files,
      "options": _vm.getFieldByName('hazi_tmdk').options,
      "id": _vm.getFieldByName('hazi_tmdk').name,
      "label": _vm.getFieldByName('hazi_tmdk').label,
      "name": _vm.getFieldByName('hazi_tmdk').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'hazi_tmdk');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name,
    ref: "egyeb_szakmai_tanulmanyi_versenyek",
    attrs: {
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').accepted_files,
      "options": _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').options,
      "id": _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name,
      "label": _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').label,
      "name": _vm.getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'egyeb_szakmai_tanulmanyi_versenyek');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name,
    ref: "egyeb_kiemelkedo_szakmai_tevekenyseg",
    attrs: {
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').accepted_files,
      "options": _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').options,
      "id": _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name,
      "label": _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').label,
      "name": _vm.getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'egyeb_kiemelkedo_szakmai_tevekenyseg');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('egyeb_szakmai_tevekenyseg').name,
    ref: "egyeb_szakmai_tevekenyseg",
    attrs: {
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('egyeb_szakmai_tevekenyseg').accepted_files,
      "options": _vm.getFieldByName('egyeb_szakmai_tevekenyseg').options,
      "id": _vm.getFieldByName('egyeb_szakmai_tevekenyseg').name,
      "label": _vm.getFieldByName('egyeb_szakmai_tevekenyseg').label,
      "name": _vm.getFieldByName('egyeb_szakmai_tevekenyseg').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'egyeb_szakmai_tevekenyseg');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Jelen projekt keretében már részesült ösztöndíjban")]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.reszesult_osztondijban),
      expression: "form.values.reszesult_osztondijban"
    }],
    attrs: {
      "id": "reszesult_osztondijban",
      "name": "reszesult_osztondijban",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.reszesult_osztondijban) ? _vm._i(_vm.form.values.reszesult_osztondijban, "1") > -1 : (_vm.form.values.reszesult_osztondijban)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.reszesult_osztondijban,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.reszesult_osztondijban = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.reszesult_osztondijban = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.reszesult_osztondijban = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.reszesult_osztondijban),
      expression: "form.values.reszesult_osztondijban"
    }],
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('reszesult_osztondijban_mtmt').name,
    ref: "reszesult_osztondijban_mtmt",
    attrs: {
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('reszesult_osztondijban_mtmt').accepted_files,
      "options": _vm.getFieldByName('reszesult_osztondijban_mtmt').options,
      "id": _vm.getFieldByName('reszesult_osztondijban_mtmt').name,
      "label": _vm.getFieldByName('reszesult_osztondijban_mtmt').label,
      "name": _vm.getFieldByName('reszesult_osztondijban_mtmt').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'reszesult_osztondijban_mtmt');
      }
    }
  })], 1), _vm._v(" "), (!_vm.doktorandusz()) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandlerWithComboAddRemove', {
    key: _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name,
    ref: "megjelent_publikaciok_mtmt_lista_alapjan",
    attrs: {
      "tooltipDescription": "Tételes lista a pályázat benyújtásának időpontjáig megjelent publikációkról: MTMT-ből nyomtatott teljes lista a presztízs és szponzor adatok jelölésével, valamint az MTMT Közlemény és idéző összefoglaló táblázat",
      "hide_point": true,
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "accepted_files": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').accepted_files,
      "options": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').options,
      "id": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name,
      "label": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').label,
      "name": _vm.getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'megjelent_publikaciok_mtmt_lista_alapjan');
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.adatvedelem),
      expression: "form.values.adatvedelem"
    }],
    attrs: {
      "id": "adatvedelem",
      "name": "adatvedelem",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.adatvedelem) ? _vm._i(_vm.form.values.adatvedelem, "1") > -1 : (_vm.form.values.adatvedelem)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.adatvedelem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.adatvedelem = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.adatvedelem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.adatvedelem = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'adatvedelem') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.nyilatkozat),
      expression: "form.values.nyilatkozat"
    }],
    attrs: {
      "id": "nyilatkozat",
      "name": "nyilatkozat",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.nyilatkozat) ? _vm._i(_vm.form.values.nyilatkozat, "1") > -1 : (_vm.form.values.nyilatkozat)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.nyilatkozat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.nyilatkozat = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.nyilatkozat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.nyilatkozat = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozat') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "ment"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }), _vm._v(" "), (_vm.remedy) ? _c('div', [_c('div', {
    staticClass: "info-box warning",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n            Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)",
      "title": ""
    },
    on: {
      "click": function($event) {
        _vm.remedy_popup = true;
      }
    }
  }, [_vm._v("Fellebezés")])]) : _vm._e(), _vm._v(" "), (_vm.remedy_user != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_user.name))]), _vm._v(" (" + _vm._s(_vm.remedy_user.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_user.msg))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.remedy_admin != false) ? _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fellebezés válasz")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.remedy_admin.name))]), _vm._v(" (" + _vm._s(_vm.remedy_admin.created) + ")")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.nl2br(_vm.remedy_admin.msg))
    }
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.remedy && _vm.$route.query.id != undefined && _vm.remedy_popup) ? _c('Fellebezes', {
    attrs: {
      "form_id": _vm.$route.query.id
    },
    on: {
      "close": function (final) {
        _vm.remedy_popup = false;
        if (final) { _vm.remedy = false; }
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n          Alapadatok\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Kutatás\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Mellékletek\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Opcionális\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "reszesult_osztondijban"
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n          Adatvédelem\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Adatvédelmi nyilatkozat")]), _vm._v(" "), _c('div', {
    staticClass: "form-scroll-block"
  }, [_vm._v("A jelentkezési lapon szereplő személyes adatok kezelése az érintett önkéntes hozzájárulásán alapul, mely hozzájárulást az érintett a pályázati adatlap kitöltésével és annak aláírásával ad meg."), _c('br'), _c('br'), _vm._v("Az adatkezelők harmadik személy(ek) részére adattovábbítást nem végeznek."), _c('br'), _c('br'), _vm._v("Az érintett hozzájárulása indokolás nélkül bármikor visszavonható."), _c('br'), _c('br'), _vm._v("A kezelt adatokba betekintést kizárólag az adatkezelők ösztöndíj elnyerésére való jogosultság megállapításával, annak elbírálásával, valamint az ösztöndíj folyósításával összefüggő feladatokat ellátó munkatársa(i) nyerhet(nek) a fenti feladatok ellátásához szükséges ideig és mértékben. A jelentkezési lapon szereplő adatok a jelentkezés sikertelensége esetén az elbírálást követő 1 hónapig kezelhetőek."), _c('br'), _c('br'), _vm._v("Pozitív elbírálás esetén a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 / EFOP-3.6.3-VEKOP-16-2017-00008 pályázat keretében az ösztöndíjas hallgatóról megismert személyes adatokat az ösztöndíjszerződés lejáratát követő 8 évig jogosult kezelni."), _c('br'), _c('br'), _vm._v("Az érintett az adatkezelés teljes időtartama alatt élhet az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvényben biztosított jogával, (tájékoztatáshoz, helyesbítéshez, törléshez, zároláshoz, tiltakozáshoz való jog) továbbá jogsérelem esetén bírósághoz, valamint a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest, Szilágyi Erzsébet fasor 22/c., tel.: 06-1-391-1400, honlap URL címe: http://naih.hu, elektronikus levelezési cím: ugyfelszolgalat@naih.hu ) is fordulhat.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "adatvedelem"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n              Adatvédelmi nyilatkozat elfogadása\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Nyilatkozat")]), _vm._v(" "), _c('div', {
    staticClass: "form-scroll-block"
  }, [_vm._v("A pályázat beadásával büntetőjogi felelősségem tudatában kijelentem, hogy az általam közölt adatok a valóságnak megfelelnek, és ellenőriztem, hogy minden adatom helyesen szerepel a Neptun Hallgatói Információs Rendszerben. Különös tekintettel a pályázathoz szükséges adatokra (név, születési hely és idő, édesanyja neve, taj szám, számlaszám, adószám, állandó lakcím)."), _c('br'), _c('br'), _vm._v("Tudomásul veszem, hogy valótlan adatok megadása az ösztöndíj programból történő kizárást eredményezi."), _c('br'), _c('br'), _vm._v("Nyilatkozom, hogy a pályázati felhívást megismertem, az abban foglaltakat tudomásul vettem és a pályázat elnyerése esetén magamra kötelezőnek ismerem el."), _c('br'), _c('br'), _vm._v("Az adatvédelmi tájékoztató ismeretében hozzájárulok, hogy a fent megadott személyes adataimat a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 / EFOP-3.6.3-VEKOP-16-2017-00008 pályázattal összefüggésben személyes kezelje.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozat"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n              Nyilatkozat elfogadása\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12db9438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/utanpotlas_hallgatoi_osztondij.vue
// module id = 331
// module chunks = 0